import { ThemeProvider } from '@emotion/react';
import { CssBaseline, Portal } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { enUS, hu } from 'date-fns/locale';

import LogoutConfirmDialog from '../../auth/components/LogoutConfirmDialog';
import { selectCurrentTheme, selectCurrentLanguage } from '../../settings/store/settingsSlice';
import FullPageLoaderPage from '../pages/FullPageLoaderPage';
import AppBarWithDrawerMenu from './AppBarWithDrawerMenu';
import GeneralErrorHandler from './GeneralErrorhandler';
import GeneralUserActionSuccessHandler from './GeneralUserActionSuccessHandler';

const Layout: React.FC = () => {
  const theme = useSelector(selectCurrentTheme);
  const language = useSelector(selectCurrentLanguage);

  // Map language to date-fns locale
  const getDateFnsLocale = () => {
    switch (language) {
      case 'en':
        return enUS;
      case 'hu':
        return hu;
      default:
        return enUS;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={getDateFnsLocale()}
        dateFormats={{
          fullDate: 'yyyy-MM-dd',
          keyboardDate: 'yyyy-MM-dd',
        }}
      >
        <GeneralErrorHandler />
        <Suspense>
          <GeneralUserActionSuccessHandler />
        </Suspense>

        <Suspense fallback={<FullPageLoaderPage />}>
          <Portal>
            <LogoutConfirmDialog />
          </Portal>
          <AppBarWithDrawerMenu>
            <Outlet />
          </AppBarWithDrawerMenu>
        </Suspense>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default Layout;
